import { render, staticRenderFns } from "./PlanBaby.vue?vue&type=template&id=1349c262&scoped=true&"
import script from "./PlanBaby.vue?vue&type=script&lang=js&"
export * from "./PlanBaby.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1349c262",
  null
  
)

export default component.exports